exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".e-notes-icon[data-v-01d8420a]:before{content:\"\\EC26\";color:rgba(0,0,0,.54);font-size:18px;padding-right:13px}", ""]);

// exports
